import { CalcRepairController, ApiCrudObjectControllerBindings } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Editor for repairing the given calculation.
 * @example
 * ```html
 * <salaxy-calc-repair model="'url'"></salaxy-calc-repair>
 * ```
 */
export class CalcRepair extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = (new class extends ApiCrudObjectControllerBindings {



    }());

    /** Uses the CalcReportController */
    public controller = CalcRepairController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/CalcRepair.html";

}
